/* ---------- Hero: the finding beside the study's own Figure 1 ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-16);
  background: var(--surface-alt);
}
.heroGrid {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.heroText > * {
  max-width: 38rem;
}
.heroTitle {
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
.heroActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-4) var(--sp-8);
  margin-top: var(--sp-8);
}
.heroLink {
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.heroLink:hover {
  color: var(--accent-text);
}
/* The paper's own reference, as a citation under the actions. */
.citation {
  margin: var(--sp-8) 0 0;
  padding-left: var(--sp-4);
  border-left: 2px solid var(--border-strong);
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.citation cite {
  font-style: italic;
  color: var(--text);
}
.heroFigure {
  margin: 0;
}
.heroImage {
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
.figcaption {
  margin-top: var(--sp-3);
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
@media (min-width: 64rem) {
  .heroGrid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: var(--sp-16);
  }
}

/* ---------- The study at a glance: four figures on hairlines ---------- */
.glance {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 13rem), 1fr));
  gap: var(--sp-6) var(--sp-10);
  margin: 0;
  padding: 0;
  list-style: none;
}
.glance li {
  display: grid;
  gap: var(--sp-2);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
}
.glance strong {
  font-family: var(--font-display);
  font-size: clamp(2rem, 1.2rem + 2.2vw, 3rem);
  line-height: 1;
  letter-spacing: -0.03em;
  color: var(--text-strong);
}
.glance span {
  color: var(--text);
}
/* Phones: two by two rather than a screen of single rows. */
@media (max-width: 47.99rem) {
  .glance {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--sp-6) var(--sp-5);
  }
  .glance span {
    font-size: var(--fs-sm);
  }
}

/* ---------- The finding: the paper's sentence beside its chart ---------- */
.finding {
  display: grid;
  gap: var(--sp-10);
  align-items: center;
}
.quote {
  margin: 0;
}
.quote p {
  margin: 0;
  font-family: var(--font-display);
  font-size: clamp(1.6rem, 1rem + 1.8vw, 2.5rem);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text-strong);
  text-wrap: pretty;
}
.quote footer {
  margin-top: var(--sp-5);
  font-weight: 600;
  color: var(--accent-text);
}
.chart {
  margin: 0;
}
/* The chart is black on white in the paper; a white card keeps it that way. */
.chartImage {
  padding: var(--sp-4);
  border-radius: var(--radius-lg);
  background: #fff;
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-md);
}
@media (min-width: 64rem) {
  .finding {
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    gap: var(--sp-16);
  }
}

/* ---------- The study in its own words: numbered parts, heading beside text ---------- */
.parts {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: part;
}
.parts li {
  display: grid;
  gap: var(--sp-4) var(--sp-16);
  padding-block: var(--sp-8);
  border-top: 1px solid var(--border-strong);
  counter-increment: part;
}
.parts h3 {
  display: flex;
  align-items: baseline;
  gap: var(--sp-3);
  margin: 0;
  font-size: var(--fs-xl);
}
/* The paper's order, numbered: question, method, results, what it means. */
.parts h3::before {
  content: counter(part, decimal-leading-zero);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--accent-text);
}
.partBody {
  display: grid;
  gap: var(--sp-4);
  max-width: 46rem;
}
.partBody p {
  margin: 0;
  color: var(--text);
}
.download {
  margin: var(--sp-8) 0 0;
}
@media (min-width: 64rem) {
  .parts li {
    grid-template-columns: minmax(0, 4fr) minmax(0, 8fr);
  }
}
